function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.89001,
    height: 62.98651,
    viewBox: "0 0 57.89001 62.98651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.88599,40.99225V21.99225c0-3.74887-2.00018-7.21292-5.24701-9.08701L34.18799,3.40524c-3.24677-1.875-7.24725-1.875-10.49402,0L7.24298,12.90524c-3.24683,1.87408-5.24701,5.33813-5.24701,9.08701v19c0,3.74887,2.00018,7.21292,5.24701,9.08701l16.45099,9.5c3.24677,1.875,7.24725,1.875,10.49402,0l16.45099-9.5c3.24683-1.87408,5.24701-5.33813,5.24701-9.08701",
    style: {
      fill: "#f7ac52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M55.89001,40.99326V21.99326c0-3.74887-2.00018-7.21292-5.24701-9.08701L34.19202,3.40625c-3.24677-1.875-7.24725-1.875-10.49402,0L7.24701,12.90625c-3.24683,1.87408-5.24701,5.33813-5.24701,9.08701v19c0,3.74887,2.00018,7.21292,5.24701,9.08701l16.45099,9.5c3.24677,1.875,7.24725,1.875,10.49402,0l16.45099-9.5c3.24683-1.87408,5.24701-5.33813,5.24701-9.08701Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M37.73698,36.50925c.00753,.61018-.22774,1.19833-.654,1.63499-.75963,.85362-2.06743,.92982-2.92105,.1702-.0686-.06105-.13305-.12659-.19295-.1962-.43063-.42523-.67515-1.00381-.68-1.60899,.00022-1.22829,.99611-2.22383,2.22439-2.2236,1.22798,.00021,2.22339,.99562,2.22361,2.2236Zm2.459-13.92l-15.777,18.5h-6.724l15.8-18.5h6.701Zm-15.62,4.657c.00813,.59119-.22857,1.15942-.654,1.57001-.41058,.42543-.97881,.66214-1.57,.65401-.58043-.00949-1.1306-.26065-1.518-.69299-.42491-.397-.67034-.94957-.68-1.53101,.00613-.59091,.24594-1.15538,.667-1.57001,.38563-.44379,.94309-.70085,1.531-.70599,.59613-.00647,1.16691,.24075,1.57,.67999,.42343,.42262,.65911,.99777,.654,1.59599Z",
    style: {
      fill: "#b37d3b"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard3);
export default __webpack_public_path__ + "static/media/Artboard_3.0f9d01b8dd127d4b317b28bdd13113d6.svg";
export { ForwardRef as ReactComponent };